


























import Vue from "vue";
import {Expandable} from "@/componentsReusable/Expandable";
import SaveCancelDeleteButtonPanel from "@/componentsReusable/SaveCancelDeleteButtonPanel.vue";
import AddItemHyperlink from "@/componentsReusable/AddItemHyperlink.vue";
import {Writeable} from "@/interfaces/Writeable";

export default Vue.component('CrudList', {
  props: {
    rows: {
      type: Array as () => Expandable[],
      required: true
    },
    canAdd: {
      type: Boolean,
      defaultValue: true
    },
    entityName: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      defaultValue: true
    }
  },
  methods: {
    toggleEdit(item: any) {
      if (this.canEdit) {
        this.$emit('toggle-edit', item);
      }
    },
    addNew(item: any) {
      this.$emit('add-new', item);
    },
    cancel(writeable: Writeable) {
      this.$emit('cancel', writeable);
    },
    create(writeable: Writeable) {
      this.$emit('create', writeable);
    },
    update(writeable: Writeable) {
      this.$emit('update', writeable);
    },
    doDelete(writeable: Writeable) {
      this.$emit('delete', writeable);
    }
  },
  components: {
    SaveCancelDeleteButtonPanel,
    AddItemHyperlink
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/CrudList.vue